"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postTenant = exports.sendEmail = exports.updatePlatformConfig = void 0;
const http_1 = require("../http");
const config_1 = require("../config");
const http = new http_1.default();
function updatePlatformConfig(data, callback = null) {
    http.get(config_1.default.IBL_EDX.UPDATE_PLATFORM_CONFIG, data, (data) => {
        callback && callback(data);
    }, (error) => {
        console.error('Error occurred:', error);
    }, false, 'IBL_DM_URL');
}
exports.updatePlatformConfig = updatePlatformConfig;
function sendEmail(data, callback = null) {
    http.post(config_1.default.IBL_EDX.SEND_EMAIL, data, (data) => {
        callback && callback(data);
    }, (error) => {
        console.error('Error occurred:', error);
    }, false, 'IBL_LMS_URL');
}
exports.sendEmail = sendEmail;
/**
 * Post tenant
 * @function postTenant
 * @memberof ibledxplatform
 *
 * @see https://github.com/iblai/ibl-dm-multi-services-app/blob/master/USAGE.md#launch-tenant
 *
 * @param {Object} data
 * @param {String} [data.username] platform admin username
 * @param {String} [data.email] platform admin email
 * @param {String} [data.password] platform admin password
 * @param {String} [data.firstname] platform admin firstname
 * @param {String} [data.lastname] platform admin lastname
 * @param {String} [data.role] platform admin role in organization (based on edX user roles)
 * @param {String} [data.key] platform key
 * @param {String} [data.name] platform name
 * @param {String} [data.org] platform org value
 * @param {String} [data.lms_url] platform LMS URL
 * @param {String} [data.cms_url] platform CMS URL
 * @param {String} [data.portal_url] platform WP URL
 * @param {callback} successCb
 * @param {callback} errorCb
 *
 * @example <caption>Post tenant</caption>
 * This usage:
 *
 * ```js
 * ibledxplatform.postTenant(
 *    {
 *      username: "adminUser",
 *      email: "admin@example.com",
 *      password: "securePassword123!",
 *      firstname: "Admin",
 *      lastname: "User",
 *      role: "role",
 *      key: "platformKey123",
 *      name: "PlatformName",
 *      org: "OrgValue",
 *      lms_url: "https://lms.example.com",
 *      cms_url: "https://cms.example.com",
 *      portal_url: "https://portal.example.com",
 *    },
 *    (data) => console.log(data),
 *    (error) => console.error(error)
 * )
 * ```
 */
function postTenant(data, successCb, errorCb) {
    http.post(config_1.default.IBL_EDX.POST_TENANT, data, (data) => {
        successCb && successCb(data);
    }, (error) => {
        errorCb && errorCb(error);
    }, false, 'IBL_LMS_URL');
}
exports.postTenant = postTenant;
